import * as gmaps from '@google/maps/lib';
import { } from '@types/googlemaps';

const GOOGLE_MAPS_API_KEY = process.env.GOOGLE_MAPS_API_KEY;
const googleMapsClient: gmaps.GoogleMapsClient = gmaps.createClient({
  key: GOOGLE_MAPS_API_KEY,
  language: 'en',
  Promise
});

export async function geocodePosition(latitude, longitude): Promise<any>{
  // console.log(process.env);
  const location = { lat: latitude, lng: longitude };
  return googleMapsClient.reverseGeocode({ latlng: location }).asPromise();
}
